import { Subnet } from "../types/subnet";
import IPVersion from "./bits/IPVersion";

import SubnetName from "./bits/SubnetName";
import DHCPStatus from "./bits/dhcp/DHCPStatus";
import DNS from "../bits/DNS";
import { NameServerResponse } from "../../../../../api/resources/Networking/NamesServer";
import CIDR from "./bits/CIDR";
import GatewayStatus from "./bits/GatewayStatus";
import GatewayIP from "./bits/GatewayIP";
import DHCPPools from "./bits/dhcp/DHCPPools";
import SubnetPools from "./bits/pools/SubnetPools";
import HostRoutesStatus from "./bits/hostRoutes/HostRoutesStatus";
import HostRoutes from "./bits/hostRoutes/HostRoutes";
import SubnetsDivider from "./bits/Divider";
import useSubnetItem from "./hooks/useSubnetItem";
import { Grid, Ref } from "semantic-ui-react";
import { forwardRef } from "react";
import { useNetworkFormContext } from "../context/NetworkFormContext";
import useSubnetsValidation from "./hooks/useSubnetsValidation";

export type SubnetItemProps = {
  nameservers: NameServerResponse;
  index: number;
  onChange: (index: number, updated: Subnet) => void;
};

const SubnetItem = forwardRef<HTMLElement, SubnetItemProps>(
  ({ index, nameservers, onChange }, ref) => {
    const {
      handleInputChange,
      handleSelectChange,
      handleCheckboxChange,
      onAllocationPoolsChange,
      onHostRoutesChange,
      subnet,
      subnetsCount,
    } = useSubnetItem({ index, onChange, nameservers });

    const subnetsError = useSubnetsValidation();

    const { formWarning } = useNetworkFormContext();

    const className = `padding-top-10 padding-bottom-20 ${formWarning && subnetsError && index === subnetsError.refIndex ? "shake error-form-group" : "---"}`;

    return (
      <Ref innerRef={ref}>
        <Grid.Row className={className}>
          {index > 0 && <SubnetsDivider />}

          <SubnetName
            onChange={handleInputChange}
            index={index}
            name={subnet.name}
            subnetsCount={subnetsCount}
          />
          <IPVersion
            onChange={handleCheckboxChange}
            ipVersion={subnet.ipVersion}
            index={index}
          />

          {/* 4 */}
          {subnet.ipVersion === 4 && (
            <>
              <CIDR onChange={handleInputChange} cidr={subnet.cidr} />

              <GatewayStatus
                onChange={handleCheckboxChange}
                enableGateway={subnet.enableGateway}
              />
              {subnet.enableGateway && (
                <GatewayIP
                  onChange={handleInputChange}
                  gatewayIp={subnet.gatewayIp}
                />
              )}

              <DHCPStatus
                onChange={handleCheckboxChange}
                enableDhcp={subnet.enableDhcp}
              />
              {subnet.enableDhcp && (
                <DHCPPools
                  allocationPools={subnet.allocationPools}
                  onAllocationPoolsChange={onAllocationPoolsChange}
                />
              )}
            </>
          )}

          {/* 6 */}
          {subnet.ipVersion === 6 && (
            <SubnetPools
              onChange={handleSelectChange}
              subnetPool={subnet.subnetPool}
              addressingType={subnet.addressingType}
            />
          )}

          <DNS
            onChange={handleInputChange}
            dnsNameservers={subnet.dnsNameservers}
            ipVersion={subnet.ipVersion}
          />

          <HostRoutesStatus
            onChange={handleCheckboxChange}
            enabled={subnet.enableHostRoutes}
          />
          {subnet.enableHostRoutes && (
            <HostRoutes
              hostRoutes={subnet.hostRoutes}
              onHostRoutesChange={onHostRoutesChange}
            />
          )}
        </Grid.Row>
      </Ref>
    );
  },
);

export default SubnetItem;
